import { apiCustomer } from "@/api"

/**
 * POST /orders/:orderId/cancellation-request — first-party consumer
 * cancellation request (from CREATED through preparation).
 */
export async function requestOrderCancellation(
  orderId: string,
  reason: string,
): Promise<void> {
  await apiCustomer.post(`/orders/${orderId}/cancellation-request`, {
    reason: reason.trim(),
  })
}
